import React from "react";
import { Link } from "react-router-dom";
import FooterLogo from "../../Assets/Images/footer-logo.png";
import Pdf from "../../Assets/Images/privacy-policy.pdf";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-group">
          <div className="footer-header">
            <p>
              Do you want to know more? Or just have a question? Write to us.
            </p>
          <Link to="/contact"><button className="yellow-btn">Contact Us Now</button></Link>
          </div>

          <div className="footer-desc">
            <ul>
              <li>
                <Link to="/">
                  <div className="footer-logo">
                    <img src={FooterLogo} />
                  </div>
                </Link>
              </li>

              <li>
                <h4>Customers</h4>
                <p>Blog</p>
                <p>
                  <Link to="/partner">Become a partner</Link>
                </p>
                <p>
                  <Link to="/contact">Contact us</Link>
                </p>
              </li>

              <li>
                <h4>Merchants</h4>
                <p>
                <a href="http://intransit-test.s3-website.ap-south-1.amazonaws.com/file-claim" target="_blank">
                {/* <a href="http://localhost:3000/file-claim" target="_blank"> */}
                File a claim
                </a>
                  {/* <Link to="/file-claim"> File a claim</Link> */}
                </p>
                <p>
                  <Link to="/sms-policy">SMS Policy</Link>
                </p>
                <p>
                  <Link to="/guideline">Community Guidelines</Link>
                </p>
              </li>

              <li>
                <h4>Company</h4>
                <p>
                  <Link to="/faq">FAQ</Link>
                </p>
                <p>
                  <Link to="/terms">Terms & Conditions</Link>
                </p>
                <p>
                  <a href={Pdf} target="_blank">
                    Privacy Policy
                  </a>
                </p>
              </li>

              <li>
                <p>hello@transit.com</p>
                <p>+000-1234567890</p>
                <h4>Social Share</h4>
                <div className="footer-social">
                  <span>
                    <i class="fab fa-facebook-f"></i>
                  </span>
                  <span>
                    <i class="fab fa-twitter"></i>
                  </span>
                  <span>
                    <i class="fab fa-pinterest-p"></i>
                  </span>
                  <span>
                    <i class="fab fa-google"></i>
                  </span>
                  <span>
                    <i class="fab fa-instagram"></i>
                  </span>
                </div>
              </li>
            </ul>
          </div>

          <div className="footer-copyright">
            <p>© InTransit.2020.All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
